import React, { useMemo, useState, useEffect, useCallback, useContext } from 'react';

import MediumButtonStyled from '../../../components/Buttons/MediumButtonStyled';
import ContentBoardStyled from '../../../components/ContentBoardStyled';
import NoItemsInList from '../../../components/NoItemsInList';
import SearchHeader from '../../../components/SearchHeader';
import { ControlBarContext } from '../../ControlBarContext';
import Scrollable from '../../../components/Scrollable';
import CreatePartnerModal from './CreatePartnerModal';
import { useRouteMatch } from 'react-router-dom';
import Loader from '../../../components/Loader';
import Partner from './Partner';

import { usePartners, useIsLoading, useCurrentPartner, useReloadPartners } from '../context';

export default function () {
  const match = useRouteMatch();
  const partners = usePartners();
  const isLoading = useIsLoading();
  const currentPartner = useCurrentPartner();
  const reloadPartners = useReloadPartners();
  const { setRightSide } = useContext(ControlBarContext);

  const [searchInput, setSearchInput] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const inputHandler = (value) => setSearchInput(value);

  const toggleModal = useCallback(() => {
    setIsModalOpen(!isModalOpen);
  }, [isModalOpen]);

  const filtered = useMemo(() => {
    if (!searchInput) return partners;
    return partners.filter((p) => p.name.toLowerCase().includes(searchInput.toLowerCase()));
  }, [partners, searchInput]);

  useEffect(() => {
    if (currentPartner) isModalOpen(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPartner]);

  useEffect(() => {
    setRightSide({
      Component: <MediumButtonStyled onClick={toggleModal}>Add new partner</MediumButtonStyled>,
      url: match.url
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [match.url]);

  return (
    <ContentBoardStyled>
      <CreatePartnerModal
        mode='GLOBAL'
        isOpen={isModalOpen}
        toggleHandler={toggleModal}
        reloadPartners={reloadPartners}
      />
      <SearchHeader
        userInput={searchInput}
        placeholder='Search by name'
        onInputHandler={(event) => inputHandler(event.target.value)}
        onClearHandler={() => inputHandler('')}
      />
      <Scrollable isLoading={isLoading} bottomReached={() => null}>
        {Boolean(filtered?.length) && !isLoading ? (
          filtered.map((partner) => <Partner key={partner.id} partner={partner} />)
        ) : (
          <NoItemsInList>
            {!isLoading ? (searchInput ? 'No partners found' : 'No partners to show') : ''}
          </NoItemsInList>
        )}
      </Scrollable>
      <Loader isLoading={isLoading} firstLoad={!partners?.length} />
    </ContentBoardStyled>
  );
}
